 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g shadow-type-4 [height]="height()"/>
        <g wall-type-3 [height]="height()"></g>
        
        <g roof-type-3/>
        <g outline />
        <g window-type-6 [height]="height()"/>

</svg>